import { ReactNode } from "react";

export const PageLayout = ({ children, leftTopButton }: { children: ReactNode; leftTopButton?: JSX.Element }) => {
  return (
    <main className="flex h-screen w-screen flex-col p-6">
      {leftTopButton}
      <div className="flex-1">{children}</div>
    </main>
  );
};
